import { Box, Column, InputTextAreaField, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

// Figma 7737:78298 draws a 116px text area inside the field's 8px vertical padding.
const TEXTAREA_HEIGHT = 116;

export interface IOtherReasonFieldProps {
  /** Id of the textarea; the error id derives from it. */
  id: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  /** Validation message shown under the box; omit when valid or not yet shown. */
  error?: string;
}

export const OtherReasonField = ({
  id,
  value,
  onChange,
  onBlur,
  error,
}: IOtherReasonFieldProps) => {
  const errorId = `${id}-error`;

  return (
    // Figma draws no visible label; the name repeats the placeholder so speech input can target it.
    <Column>
      <InputTextAreaField
        id={id}
        data-cy="cancellation-details-textarea"
        aria-label="Add a cancellation reason"
        aria-required
        placeholder="Add a cancellation reason."
        height={TEXTAREA_HEIGHT}
        value={value}
        isError={Boolean(error)}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? errorId : undefined}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
      />
      {/* Mounted before the message (a live region inserted with its text isn't announced); padded only with one. */}
      <Box aria-live="polite" pt={error ? 1 : undefined}>
        {error && (
          <Typography
            id={errorId}
            variant="caption"
            color={colors.error[500]}
            data-cy="cancellation-details-error"
          >
            {error}
          </Typography>
        )}
      </Box>
    </Column>
  );
};
